module.exports = __webpack_public_path__ + "img/changeFineness-1@2x.a265364.png";